<div class="root">
  <div class="image">
    <img src="assets/jojo-1.jpg" alt="" />
    相談して決めましょう
  </div>
</div>
